import request from '@/plugins/axios'

export function AccountLogin(data) {
  return request({
    url: '/doLogin',
    method: 'post',
    data
  })
}